import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X, Clock } from "lucide-react";

// 7 days rolling deadline (Saturday end-of-week)
function nextDeadline() {
  const stored = localStorage.getItem("hdw_offer_deadline");
  if (stored) {
    const d = parseInt(stored, 10);
    if (d > Date.now()) return d;
  }
  const next = Date.now() + 7 * 24 * 60 * 60 * 1000;
  localStorage.setItem("hdw_offer_deadline", String(next));
  return next;
}

function pad(n) { return String(n).padStart(2, "0"); }

export default function CountdownBar() {
  const [open, setOpen] = useState(true);
  const [deadline] = useState(nextDeadline);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!open) return null;

  const ms = Math.max(0, deadline - now);
  const days = Math.floor(ms / 86_400_000);
  const hrs = Math.floor((ms % 86_400_000) / 3_600_000);
  const mins = Math.floor((ms % 3_600_000) / 60_000);
  const secs = Math.floor((ms % 60_000) / 1000);

  return (
    <div className="relative bg-gradient-to-r from-[#D32F2F] via-[#F7941D] to-[#D32F2F] text-white shadow-sm" data-testid="countdown-bar">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2 pr-10 flex items-center justify-center gap-2 sm:gap-4 flex-wrap text-center">
        <div className="flex items-center gap-1.5 text-xs sm:text-sm font-bold">
          <Flame className="w-3.5 h-3.5 sm:w-4 sm:h-4 animate-pulse text-yellow-200" />
          <span className="hidden sm:inline">LIMITED OFFER:</span>
          <span>10% OFF — Code</span>
          <span className="bg-white text-[#D32F2F] px-1.5 py-0.5 rounded text-[10px] sm:text-xs font-extrabold">FIRST10</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5 text-yellow-200" />
          <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider hidden sm:inline">Ends in:</span>
          <div className="flex items-center gap-1 font-mono text-xs sm:text-sm font-extrabold">
            <CountUnit value={days} label="d" />
            <span>:</span>
            <CountUnit value={pad(hrs)} label="h" />
            <span>:</span>
            <CountUnit value={pad(mins)} label="m" />
            <span>:</span>
            <CountUnit value={pad(secs)} label="s" />
          </div>
        </div>
        <Link to="/services" className="hidden sm:inline-block text-xs font-bold underline underline-offset-2 hover:no-underline" data-testid="countdown-cta">
          Claim Now →
        </Link>
      </div>
      <button
        onClick={() => setOpen(false)}
        data-testid="countdown-close"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-white/20 transition"
        aria-label="Close offer banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

function CountUnit({ value, label }) {
  return (
    <span className="bg-black/20 px-1.5 py-0.5 rounded">
      {value}<span className="opacity-70 text-[9px] ml-0.5">{label}</span>
    </span>
  );
}
